/**
 * Component that splits content into two columns.
 *
 * Usage:
 * <boma-card-menu>
 *   <ng-template #left>
 *     ... content for left column ...
 *   </ng-template>
 *   <ng-template #right>
 *     ... content for right column ...
 *   </ng-template>
 * </boma-card-menu>
 *
 * The content provided in the `left` and `right` ng-templates will be rendered in the
 * left and right columns of the CardMenuComponent, respectively.
 *
 * If the number of items in the content is odd, the left column will have one more item
 * than the right column.
 *
 * @example
 * <boma-card-menu>
 *   <ng-template #left>
 *     <p>Left column content</p>
 *   </ng-template>
 *   <ng-template #right>
 *     <button>Right column content</button>
 *   </ng-template>
 * </boma-card-menu>
 *
 * @export
 * @class CardMenuComponent
 * @implements {OnInit}
 */

import { Component, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'boma-card-menu',
  templateUrl: './card-menu.component.html',
  styleUrls: ['./card-menu.component.scss'],
})
export class CardMenuComponent {
  @ContentChild('left') leftTemplate: TemplateRef<any>;
  @ContentChild('right') rightTemplate: TemplateRef<any>;
}
